import React from 'react';
import {
  Stack,
  Text,
  TreatsLogo,
  useViewport,
  useDevice,
  buttonStyles,
} from '@treatwell/ui';
import clsx from 'clsx';
import styles from './BannerCTA.module.css';

export type BannerCTAProps = {
  title: string;
  cta: {
    label: string;
  };
  align: 'start' | 'center';
  description?: string;
};
export const BannerCTA = ({
  title,
  cta,
  align = 'start',
  description,
}: BannerCTAProps) => {
  const textStyles = clsx(styles.text, {
    [styles.textStart]: align === 'start',
    [styles.textCenter]: align === 'center',
  });
  const { isMobile } = useDevice();
  const isMobileViewport = useViewport({
    device: ['mobile', 'tablet'],
    serverRender: isMobile,
  });
  const titleType = isMobileViewport ? 'xlHeader' : 'mdHero';
  const descriptionType = isMobileViewport ? 'body' : 'lgHeaderRegular';
  const linkStyles = clsx(
    buttonStyles.button,
    buttonStyles.secondary,
    styles.link,
    {
      [buttonStyles.lg]: !isMobileViewport,
      [buttonStyles.md]: isMobileViewport,
    }
  );
  return (
    <Stack align={align} space="2xl">
      <Stack align={align} space="lg">
        <TreatsLogo />
        <Text as="h2" type={titleType} className={textStyles}>
          {title}
        </Text>
        {description && (
          <Text as="p" className={textStyles} type={descriptionType}>
            {description}
          </Text>
        )}
      </Stack>
      <a href="/places" className={linkStyles} data-cy="BannerCTALink">
        <Text type="bodyHeavy" className={styles.ctaText}>
          {cta.label}
        </Text>
      </a>
    </Stack>
  );
};
